<template>
<!--  <div v-if="isShown">-->
    <!-- 抽奖弹窗 -->
<!--    <div class="pop6" v-if="!hasDrawSuccess" id="pop6"-->
<!--         style="position: fixed; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);; z-index: 999;">-->
<!--      <div class="zd"></div>-->
<!--      <a href="javascript:void 0;" @click="close" class="close pa db">关闭</a>-->
<!--      <div class="pop6box" style="overflow-y:scroll;">-->
<!--        <div class="pop6cont">-->
<!--          &lt;!&ndash; 更改抽奖数量 &ndash;&gt;-->
<!--          <p class="pop6_tit1"><span>{{lotteryInfo.num}}</span>点券奖池</p>-->
<!--          <p class="pop6_tit2">100%赢好礼</p>-->
<!--          &lt;!&ndash; 圆盘抽奖 &ndash;&gt;-->
<!--          &lt;!&ndash; panel1 panel2 panel3 代表三个转盘内容的不同 &ndash;&gt;-->
<!--          &lt;!&ndash; nopanel可抽奖 nopanel1 未达成 nopanel2 锁定 &ndash;&gt;-->
<!--          <div class="panel panel1"-->
<!--               :class="{nopanel:lotteryInfo.status==prizeStatusEnums.AVAILABLE,nopanel1:lotteryInfo.status==prizeStatusEnums.UNAVAILABLE,nopanel2:!lotteryInfo.status || lotteryInfo.status==prizeStatusEnums.LOCKED}"-->
<!--               :id="lotteryId" @click="start"></div>-->

<!--          <p class="pop6_tit3">奖品发货后，请返回游戏邮箱中领取</p>-->
<!--          <p class="pop6_tit4" v-if="lotteryInfo.probabilityTips" v-html="lotteryInfo.probabilityTips">-->

<!--          </p>-->
<!--          <div class="skinbox" v-for="(item,index) in prizePool" :key="'prizepool'+index">-->
<!--            <p class="skin_tit">{{item.name}}</p>-->
<!--            <ul class="pop6_ul c">-->
<!--              <li v-for="p in item.productid_list" :key="p">-->
<!--                <img v-if="wzryProps[p]" :src="wzryProps[p].icon" alt="">-->
<!--                <p v-if="wzryProps[p]">{{wzryProps[p].name}}</p>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="skinbox">&ndash;&gt;-->
<!--&lt;!&ndash;            <p class="skin_tit">勇者皮肤池B</p>&ndash;&gt;-->
<!--&lt;!&ndash;            <ul class="pop6_ul c">&ndash;&gt;-->
<!--&lt;!&ndash;              <li>&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="~team-pk-ui/ossweb-img/prize/skin2/skin2_1.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                <p>甄姬<br>花好月圆</p>&ndash;&gt;-->
<!--&lt;!&ndash;              </li>&ndash;&gt;-->
<!--&lt;!&ndash;              <li>&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="~team-pk-ui/ossweb-img/prize/skin2/skin2_2.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                <p>安琪拉<br>玩偶对对碰</p>&ndash;&gt;-->
<!--&lt;!&ndash;              </li>&ndash;&gt;-->
<!--&lt;!&ndash;              <li>&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="~team-pk-ui/ossweb-img/prize/skin2/skin2_3.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                <p>宫本武藏<br>万象初新</p>&ndash;&gt;-->
<!--&lt;!&ndash;              </li>&ndash;&gt;-->
<!--&lt;!&ndash;              <li>&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="~team-pk-ui/ossweb-img/prize/skin2/skin2_4.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                <p>关羽<br>龙腾万里</p>&ndash;&gt;-->
<!--&lt;!&ndash;              </li>&ndash;&gt;-->
<!--&lt;!&ndash;            </ul>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; 抽奖结果 &ndash;&gt;-->
<!--    <div class="pop7" v-show="hasDrawSuccess"-->
<!--         style="position: fixed; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);; z-index: 999;">-->
<!--      <div class="zd"></div>-->
<!--      <a href="javascript:void 0;" @click="close" class="close pa db">关闭</a>-->
<!--      <p class="pop7_tit1">{{lotteryInfo.num}}点券奖池</p>-->
<!--      <p class="pop7_tit2">100%赢好礼</p>-->

<!--      <div class="pop7_box btn_box c" v-if="lotteryInfo.award && lotteryInfo.award.length>0">-->
<!--        <div class="propbox" v-for="award in lotteryInfo.award" :key="award.award_id">-->
<!--          <img :src="award.url" alt="">-->
<!--          <p class="prop_name">{{award.name}}</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash;      <div v-if="lotteryInfo.award && lotteryInfo.award.length>0">&ndash;&gt;-->
<!--      &lt;!&ndash;        <div class="pop7_box"  v-for="award in lotteryInfo.award" :key="award.award_id">&ndash;&gt;-->
<!--      &lt;!&ndash;          <img :src="award.url" alt="">&ndash;&gt;-->
<!--      &lt;!&ndash;          <p class="prop_name">{{award.name}}</p>&ndash;&gt;-->
<!--      &lt;!&ndash;          <a href="javaScript:void 0;" @click="closeLottery" class="accept popbtn">开心收下</a>&ndash;&gt;-->
<!--      &lt;!&ndash;        </div>&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->
<!--      <div class="pop7_box btn_box c" v-else>-->
<!--        <div class="propbox">-->
<!--          <img :src="currentAward.url" alt="">-->
<!--          <p class="prop_name">{{currentAward.name}}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash;      <div class="pop7_box" v-else>&ndash;&gt;-->
<!--      &lt;!&ndash;        <img :src="currentAward.url" alt="">&ndash;&gt;-->
<!--      &lt;!&ndash;        <p class="prop_name">{{currentAward.name}}</p>&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->
<!--      <a href="javaScript:void 0;" @click="receive" class="accept popbtn" v-if="userAgent.QQ || userAgent.weixin">进入游戏</a>-->
<!--      <p class="pop7_tit3">奖品发货后，请返回游戏邮箱中领取</p>-->
<!--    </div>-->

<!--    <div-->
<!--      style="background-color: rgb(17, 17, 17); border-top: 1px solid rgb(17, 17, 17); position: absolute; z-index: 998; width: 100%; left: 0px; top: 0px; opacity: 0.7; display: block;"-->
<!--      :style="{height:maskHeight+'px'}"></div>-->
<!--    -->
<!--  </div>-->
  <div v-if="isShown">
    <div class="Dialog jc-prize" v-if="!hasDrawSuccess">
      <div class="inner">
        <i class="close" @click="close"></i>
        <div class="jc-prize-box">
          <div class="circle-prize">
            <div class="title">{{lotteryInfo.num}}{{gameInfo.shop.currency}}奖池</div>
            <p class="txt">100%赢好礼～</p>
            <!-- panel1 panel2 panel3 代表三个转盘内容的不同 -->
            <!-- nopanel可抽奖 nopanel1 未达成 nopanel2 锁定 -->
<!--            <div class="panel panel1 nopanel":id="lotteryId" @click="emulateDraw">-->
<!--              <div class="panel-face"></div>-->
<!--              <div class="panel-btn"></div>-->
<!--            </div>-->
                  <div class="panel panel1"
                           :class="{nopanel:lotteryInfo.status==prizeStatusEnums.AVAILABLE,nopanel1:lotteryInfo.status==prizeStatusEnums.UNAVAILABLE,nopanel2:!lotteryInfo.status || lotteryInfo.status==prizeStatusEnums.LOCKED}"
                           :id="lotteryId" @click="start"></div>
          </div>

          <p class="prize-tips"> <img src="~2021team-pk-ui/assets/prize-tips.png" alt=""> 奖品发货后，请返回游戏邮件中领取
          </p>
          <p class="prize-tips">
            奖池概率请见活动规则
          </p>
          <div class="caption" v-show="prizePool.length>0">
            <img class="caption-l" src="~2021team-pk-ui/assets/index-title-icon-l.png" alt="">
            年货节奖池大赏
            <img class="caption-r" src="~2021team-pk-ui/assets/index-title-icon-r.png" alt="">
          </div>
          <p class="prize-tip2" v-show="prizePool.length>0 && lotteryInfo.probabilityTips">{{lotteryInfo.probabilityTips}}</p>
          <div class="prize-props" v-show="prizePool.length>0">
            <div class="prize-props-scroll">
              <div v-for="(item,index) in prizePool" :key="'prizepool'+index">
                <div class="prize-item-title">
                  <img src="~2021team-pk-ui/assets/rule-icon.png" alt=""> {{item.name}}
                </div>

                <div class="prize-item-box">
                  <div class="prize-props-item" v-for="p in item.productid_list" :key="p">
                    <img v-if="wzryProps[p]" :src="wzryProps[p].icon" alt="">
                    <p v-if="wzryProps[p]">{{wzryProps[p].name}}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
    <Award v-show="hasDrawSuccess" :currency-name="gameInfo.shop.currency" :current-award="currentAward" :lottery-info="lotteryInfo" :on-close="close"></Award>
    <toast :toast-msg="toastMsg"></toast>
  </div>

</template>

<script>
import { mapActions, mapState } from "vuex"
import PanelLotery from "../panelLottery"
import Toast from "./Toast.vue"
import Award from "./Award.vue"
import * as config from "../config"
import myMixin from "./mixin"
export default {
  name: "DiscLottery",
  props: ["isShown", "onComplete", "lotteryId", "lotteryInfo", "gameInfo"],
  components: {
    Toast,
    Award
  },
  mixins: [myMixin],
  data() {
    return {
      maskHeight: "",
      panel: "",
      hasDrawSuccess: false,
      isClickingStart: false,
      prizeStatusEnums: config.PRIZESTATUS,
      productList: "",
      currentAward: "",
      prizePool: "",
      wzryProps: "",
      toastMsg: "",
      retryCountDown: 10
    }
  },
  computed: {
    ...mapState(["userAgent"])
  },
  mounted() {
    this.maskHeight = document.documentElement.scrollHeight

    if (this.lotteryInfo.award && this.lotteryInfo.award.length > 0) {
      this.hasDrawSuccess = true
      this.reportUserAction({
        iformat: config.REPORT.PAGEVIEW.LOTTERY_DRAW_SUCCESS_ITEM,
        resultInfo: this.lotteryInfo
      })
    } else {
      this.productList = this.gameInfo.luckDrawItem.filter(item => this.lotteryInfo.num == item.num)[0]
      this.prizePool = this.productList.prize
        .filter(item => item.productid_list && item.productid_list.length > 0)
        .sort((a, b) => a?.order - b?.order)
      this.panel = new PanelLotery({
        length: 6,
        el: `#${this.lotteryId}`,
        bg: config.GAME_INFO.luckDrawItem.filter(item => this.lotteryInfo.num == item.num)[0].img_url
      })
      this.getWzryPropsConfig().then(res => {
        this.wzryProps = res
      })

      if (this.lotteryInfo.status == this.prizeStatusEnums.AVAILABLE) {
        this.reportUserAction({
          iformat: config.REPORT.PAGEVIEW.LOTTERY_CAN_DRAW,
          resultInfo: this.lotteryInfo
        })
      } else {
        this.reportUserAction({
          iformat: config.REPORT.PAGEVIEW.LOTTERY_CANNT_DRAW,
          resultInfo: this.lotteryInfo
        })
      }
    }
  },
  methods: {
    ...mapActions(["luckyDraw", "reportUserAction", "getDrawList", "getWzryPropsConfig"]),
    receive() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.DRAW_RECEIVED
      })
      location.href = config.GAME_INFO.GAME_URL
    },
    draw() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.START_DRAW,
        resutInfo: this.lotteryInfo
      })
      this.isClickingStart = true
      this.luckyDraw({ num: this.lotteryInfo.num, code_id: this.lotteryInfo?.qualification?.[0]?.code_id })
        .then(res => {
          this.currentAward = res.luckdraw_info.luckydraw_result[0].luck_got_goods[0]
          let award_product_id = res.luckdraw_info.luckydraw_result[0].luck_got_goods[0].product_id,
            award_index = -1

          if (this.productList && this.productList.prize) {
            //先从配置奖品里面找
            this.productList.prize.forEach(item => {
              if (item.product_id == award_product_id) {
                award_index = +item.draw_index
              }
            })
            //如果找不到尝试去皮肤或英雄池找
            if (award_index == -1) {
              let skinOrHeroItem = this.productList.prize.filter(
                item => item.productid_list && item.productid_list.indexOf(award_product_id) > -1
              )[0]
              //找到了就把当前皮肤池索引当做奖品索引
              if (skinOrHeroItem) {
                award_index = +skinOrHeroItem.draw_index
              } else {
                award_index = 0
              }
            }
          }

          // this.getWzryPropsConfig().then(res => {
          //   if (res[award_product_id]) {
          //     //是皮肤或英雄
          //     //去配置里面找皮肤池或英雄池
          //     let skinOrHeroItem = this.productList.prize.filter(
          //       item => item.productid_list && item.productid_list.indexOf(award_product_id) > -1
          //     )[0]
          //     award_index = skinOrHeroItem.draw_index
          //   } else {
          //     //其他奖品
          //     if (this.productList && this.productList.prize) {
          //       this.productList.prize.forEach(item => {
          //         if (item.product_id == award_product_id) {
          //           award_index = item.draw_index
          //         }
          //       })
          //     }
          //   }
          // })

          this.panel.playto(award_index, () => {
            this.isClickingStart = false
            this.hasDrawSuccess = true
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.LOTTERY_DRAW_SUCCESS_ITEM,
              resultInfo: this.currentAward
            })
          })
        })
        .catch(res => {
          let msg = `系统繁忙，请稍后再试！(${res.ret})`
          if (res && res.msg && res.err_code == "") {
            msg = res.msg
            this.toastMsg = msg

            setTimeout(() => {
              this.toastMsg = ""
            }, 2000)
            this.isClickingStart = false
          } else {
            this.retryCountDown = 10
            msg = `哎呀，活动太火爆啦！<br>排队进入${this.retryCountDown}……`
            this.toastMsg = msg
            let queueTimer = setInterval(() => {
              this.retryCountDown--
              msg = `哎呀，活动太火爆啦！<br>排队进入${this.retryCountDown}……`
              this.toastMsg = msg
              if (this.retryCountDown == 0) {
                this.isClickingStart = false
                this.toastMsg = ""
                clearInterval(queueTimer)
              }
            }, 1000)
          }

          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.DRAW_ERROR,
            resultInfo: res
          })
        })
    },
    start(e) {
      if (e.target.classList.contains("panel-btn") && this.lotteryInfo.status == this.prizeStatusEnums.AVAILABLE) {
        if (!this.isClickingStart) {
          e.preventDefault()
          if (this.panel.playing) return
          this.draw()
        }
      }
    },
    emulateDraw() {
      this.draw()
      // this.panel.playto(3, () => {
      //   this.isClickingStart = false
      //   this.hasDrawSuccess = true
      //   this.reportUserAction({
      //     iformat: config.REPORT.PAGEVIEW.LOTTERY_DRAW_SUCCESS_ITEM,
      //     resultInfo: this.currentAward
      //   })
      // })
    }
  }
}
</script>

<style scoped>
</style>
